import { CommonResponseModel } from '@needle-management/shared-models';
import { Injectable } from '@nestjs/common';
import { MaterialRequestRepository } from './material-request-repo';
import { MaterialRequestDTO } from './material-request-dto';
import { MaterialRequestEntity } from './material-request-entity';
import { StockInRepository } from '../stock-in/repositories/stock-in.repository';
import { StockInEntity } from '../stock-in/entities/stock-in.entity';

@Injectable()
export class MaterialRequestService {
  constructor(
    private materialRequestRepo: MaterialRequestRepository,
    private stockInRepo: StockInRepository
  ) {}

  async createMaterialRequest(
    req: MaterialRequestDTO,
    isUpdate: boolean
  ): Promise<CommonResponseModel> {
    console.log(req, 'pppppppppp');
    try {
      const entity = new MaterialRequestEntity();
      entity.date = req.date;
      entity.module = req.module;
      entity.machineId = req.machineTypeId;
      entity.needleModelId = req.needleModelId;
      entity.needleQuantity = req.needleQuantity;
      entity.needleSizeId = req.needleSizeId;
      entity.purpose = req.purpose;
      entity.shift = req.shift;
      entity.isActive = req.isActive;
      entity.createdUser = req.createdUser;
      entity.updatedUser = req.updatedUser;
      entity.versionFlag = req.versionFlag;
      entity.mechanicName = req.mechanicName;
      entity.needlePointId = req.needlePointId;
      // const stockEntity = new StockInEntity()
      const save = await this.materialRequestRepo.save(entity);
      if (save) {
        return new CommonResponseModel(true, 1, 'Created successfully', save);
      } else {
        return new CommonResponseModel(
          false,
          0,
          'Something went wrong in Material Request creation',
          []
        );
      }
    } catch (err) {
      console.error(err);
      return new CommonResponseModel(
        false,
        0,
        'An error occurred during creation',
        []
      );
    }
  }

 async getMaterialRequest(): Promise<CommonResponseModel> {
  try {
    const data = await this.materialRequestRepo.getMaterialRequest();
    // const findStockIn = await this.stockInRepo.find();

    // for (const req of data) {
    //   let availableQty = 0;
    //   for (const stock of findStockIn) {
    //     if (stock.pointTypeId === req.needlePointId &&  stock.modelId === req.needleModelId &&  stock.sizeId === req.needleSizeId) {
    //       availableQty += (stock.quantity - stock.issuedQuantity);
    //     }
    //   }
    //   req.availableQty = availableQty;
    // }

    if (data.length > 0) {
      return new CommonResponseModel(true, 1, 'Data retrieved successfully', data);
    } else {
      return new CommonResponseModel(false, 0, 'No Data found', []);
    }
  } catch (err) {
    console.log(err);
  }
}

}
